/* Screenshelf: show one price only.
   BSS B2B adds struck-through original prices plus ex-VAT and inc-VAT versions for trade customers.
   This keeps a single price per card / product: the current (trade) price, inc or ex VAT to match the header VAT switch. */
(function(){
  'use strict';
  var $$=function(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s));};
  var HAS_AMOUNT=/\d[\d.,]*\s*$|€\s*\d|\d\s*€/;
  function wantInc(){var t=document.getElementById('vatToggle');return !t||t.checked;}
  function hide(el,why){el.style.setProperty('display','none','important');el.setAttribute('data-ss-hidden',why||'1');}
  function show(el){if(el.getAttribute('data-ss-hidden')==='1'){el.style.removeProperty('display');el.removeAttribute('data-ss-hidden');}}
  function visible(el){return el.offsetParent!==null||getComputedStyle(el).position==='fixed';}
  function hasAmount(el){return HAS_AMOUNT.test((el.textContent||'').replace(/\s+/g,' ').trim());}

  /* BSS Volume Pricing ("Buy More - Save More") table: BSS puts it next to / inside the price.
     Move it out of the price box into the slot above Add to cart, so hiding a duplicate price never hides the table. */
  function moveQb(){
    $$('.ss .ss-pricebox').forEach(function(pb){
      var bb=pb.closest('.ss-buybox');var slot=bb&&bb.querySelector('.bss-b2b-qb-table');if(!slot)return;
      $$('table',pb).forEach(function(tb){
        var n=tb;
        while(n.parentElement&&n.parentElement!==pb&&!n.parentElement.matches('.ss-price,.bss-b2b-product-vat,[bss-b2b-featured-product]'))n=n.parentElement;
        if(slot.contains(n))return;
        while(slot.firstChild)slot.removeChild(slot.firstChild);
        slot.appendChild(n);
      });
      /* if BSS placed it directly after the price element (outside the price box) */
      var nx=pb.nextElementSibling;
      while(nx&&!nx.matches('.ss-grades,[bss-b2b-quickview-product-form]')){
        var cur=nx;nx=nx.nextElementSibling;
        if(cur.querySelector&&cur.querySelector('table')&&!slot.contains(cur)){while(slot.firstChild)slot.removeChild(slot.firstChild);slot.appendChild(cur);}
      }
    });
  }

  function tidy(group){
    var boxes=$$('.ss-pcard__price, .ss-price, .bss-b2b-collection-item-vat, .bss-b2b-product-vat',group);
    /* 1. never show struck-through (original / compare-at) prices */
    boxes.forEach(function(box){
      $$('*',box).forEach(function(el){
        if(el.tagName==='SCRIPT'||el.tagName==='STYLE')return;
        var td=getComputedStyle(el).textDecorationLine||'';
        if(el.matches('del,s,strike,.price--compare,[class*="original-price"],[class*="compare-at"]')||td.indexOf('line-through')>-1){hide(el,'struck');}
      });
    });
    /* 2. inc / ex VAT: keep the one that matches the VAT switch */
    var inc=wantInc();
    boxes.forEach(function(box){
      $$('.bss-b2b-price-no-vat, .bss-b2b-product-vat-price-no-vat',box).forEach(function(el){inc&&hasAmount(el)?hide(el):show(el);});
      $$('.bss-b2b-price-has-vat, .bss-b2b-product-vat-price-has-vat',box).forEach(function(el){!inc&&hasAmount(el)?hide(el):show(el);});
      if(inc)$$('[data-ss-hidden="exr"]',box).forEach(function(el){el.style.removeProperty('display');el.removeAttribute('data-ss-hidden');});
    });
    /* 3. if BSS's VAT box shows a price, hide the theme price so it is not shown twice */
    var vat=group.querySelector('.bss-b2b-collection-item-vat, .bss-b2b-product-vat');
    var main=group.querySelector('.ss-pcard__price, .ss-price');
    if(vat&&main){
      var vatShows=$$('span',vat).some(function(s){return !s.getAttribute('data-ss-hidden')&&visible(s)&&hasAmount(s);});
      if(vatShows){hide(main);}else{show(main);}
    }
    /* 4. last resort: if a box still shows more than one price, keep the inc / ex VAT one */
    boxes.forEach(function(box){
      if(box.getAttribute('data-ss-hidden'))return;
      var c=$$(':scope > *',box).filter(function(el){return !el.getAttribute('data-ss-hidden')&&el.tagName!=='SCRIPT'&&el.tagName!=='STYLE'&&hasAmount(el);});
      if(c.length<2)return;
      var re=inc?/\bex(c|cl)?\.?\s*vat/i:/\binc(l)?\.?\s*vat/i;
      c.forEach(function(el){if(re.test(el.textContent))hide(el);});
    });
  }
  /* Ex VAT on the product page: BSS can show the retail price without VAT. Show the trade price without VAT instead. */
  var AM=/(?:€|£|\$)\s?\d[\d.,]*|\d[\d.,]*\s?(?:€|£|\$)/;
  function n2(t){t=String(t||'').replace(/[^\d.,]/g,'');var d=Math.max(t.lastIndexOf(','),t.lastIndexOf('.'));if(d>-1&&t.length-d-1===2)return parseFloat(t.slice(0,d).replace(/[.,]/g,'')+'.'+t.slice(d+1));return parseFloat(t.replace(/[.,]/g,''));}
  function f2(v,sample){var sym=(sample.match(/[€£$]/)||['€'])[0],c=/,\d{2}(?!\d)/.test(sample)||!/\.\d{2}(?!\d)/.test(sample);var x=(Math.round(v*100)/100).toFixed(2);if(c)x=x.replace('.',',');return sample.trim().indexOf(sym)===0?sym+x:x+sym;}
  function exFix(pb){
    var old=pb.querySelector('.ss-exvat');
    if(wantInc()){if(old)old.remove();return;}
    var main=pb.querySelector('.ss-price .price[data-ss-price]'),box=pb.querySelector('.bss-b2b-product-vat');if(!main||!box)return;
    var mt=(main.textContent||'').replace(/\s+/g,' '),mm=mt.match(AM);if(!mm)return;
    var hv=box.querySelector('[class*="has-vat"]'),nv=box.querySelector('[class*="no-vat"]');
    var a=hv&&(hv.textContent||'').match(AM),b=nv&&(nv.textContent||'').match(AM);
    var rate=(a&&b)?n2(a[0])/n2(b[0]):NaN;if(!(rate>1.001&&rate<1.3))rate=/£/.test(mt)?1.2:1.23;
    var tradeEx=/\bex(c|cl)?\.?\s*vat/i.test(mt)?n2(mm[0]):n2(mm[0])/rate;
    var shown=$$('span',box).filter(function(s){return s!==old&&!s.getAttribute('data-ss-hidden')&&visible(s)&&AM.test(s.textContent||'');});
    var bad=shown.filter(function(s){return n2((s.textContent.match(AM)||[''])[0])>tradeEx+0.05;});
    if(!bad.length){if(old&&!shown.length){}else if(old&&shown.length){old.remove();}return;}
    bad.forEach(function(s){hide(s,'exr');});
    var label=f2(tradeEx,mm[0])+' Ex. VAT';
    if(!old){old=document.createElement('span');old.className='ss-exvat';box.appendChild(old);}
    if(old.textContent!==label)old.textContent=label;
  }
  function run(){moveQb();$$('.ss .ss-pcard__body, .ss .ss-pricebox').forEach(tidy);$$('.ss-pdp .ss-pricebox').forEach(exFix);}

  var t;function later(){clearTimeout(t);t=setTimeout(run,60);}
  document.addEventListener('DOMContentLoaded',function(){
    run();
    new MutationObserver(later).observe(document.body,{childList:true,subtree:true,characterData:true});
    document.addEventListener('change',function(e){if(e.target&&e.target.id==='vatToggle')later();});
  });
  window.addEventListener('load',later);
  document.addEventListener('done_render_qb_table',later);
})();

/* v5 */
/* Screenshelf: BSS Volume Pricing ("Buy More - Save More") shown as theme-styled tier cards.
   BSS still renders its own table (it stays in the page, hidden); this reads its rows and shows them in the page's style.
   Clicking a tier sets the quantity; the tier that matches the quantity is highlighted. */
(function(){
  'use strict';
  var AMT=/(?:€|£|\$)\s?\d[\d.,]*|\d[\d.,]*\s?(?:€|£|\$)/;
  function num(t){t=String(t||'').replace(/[^\d.,]/g,'');if(!t)return NaN;var c=t.lastIndexOf(','),d=t.lastIndexOf('.');var dec=Math.max(c,d);if(dec>-1&&t.length-dec-1===2){return parseFloat(t.slice(0,dec).replace(/[.,]/g,'')+'.'+t.slice(dec+1));}return parseFloat(t.replace(/[.,]/g,''));}
  function txt(el){return (el&&el.textContent||'').replace(/\s+/g,' ').trim();}
  function esc(s){return String(s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];});}
  function visible(el){return el&&el.offsetParent!==null;}

  function findTable(){
    var pdp=document.querySelector('.ss-pdp');if(!pdp)return null;
    var t=pdp.querySelector('.bss-b2b-qb-table table');
    if(!t){var all=pdp.querySelectorAll('.ss-buybox table');for(var i=0;i<all.length;i++){if(/quantit/i.test(txt(all[i]))){t=all[i];break;}}}
    return t;
  }
  function parse(table){
    var tiers=[];
    Array.prototype.forEach.call(table.querySelectorAll('tr'),function(tr){
      var cells=tr.querySelectorAll('td');if(cells.length<2)return;
      var a=txt(cells[0]),last=txt(cells[cells.length-1]);
      var mn,mx;
      if(cells.length>=3){mn=parseInt(a,10);var b=txt(cells[1]);mx=/\+/.test(b)||!/\d/.test(b)?Infinity:parseInt(b,10);}
      else{var m=a.match(/(\d+)\s*(?:-|–|to)\s*(\d+)/i);if(m){mn=+m[1];mx=+m[2];}else{m=a.match(/(\d+)/);if(!m)return;mn=+m[1];mx=/\+|more|above/i.test(a)?Infinity:mn;}}
      if(!(mn>0))return;
      var am=last.match(AMT),pc=last.match(/(\d+(?:[.,]\d+)?)\s*%/);
      if(!am&&!pc)return;
      tiers.push({min:mn,max:isNaN(mx)?Infinity:mx,price:am?am[0].replace(/\s+/g,''):'',value:am?num(am[0]):NaN,pct:pc?num(pc[1]):NaN,vat:vatOf(last)});
    });
    tiers.sort(function(x,y){return x.min-y.min;});
    return tiers;
  }
  /* The 1-unit price, in the same VAT mode as the BSS tiers (inc or ex VAT), so savings are worked out like for like */
  function basePrice(vat){
    var pb=document.querySelector('.ss-pdp .ss-pricebox');if(!pb)return null;
    function pick(sel,needVisible,needVat){
      var els=pb.querySelectorAll(sel);
      for(var i=0;i<els.length;i++){var e=els[i];if(needVisible&&(!visible(e)||e.getAttribute('data-ss-hidden')))continue;
        if(e.querySelector&&e.querySelectorAll('*').length>3)continue;
        var tx=txt(e),m=tx.match(AMT);if(!m)continue;
        var ev=vatOf(tx)||vatOf(e.className)||(e.parentElement?vatOf(e.parentElement.className):'');
        if(needVat&&ev!==needVat)continue;
        return {text:m[0].replace(/\s+/g,''),value:num(m[0]),vat:ev};}
      return null;
    }
    var main='.ss-price .price[data-ss-price], .bss-b2b-product-vat span, .ss-price .price, [bss-b2b-product-price]';
    if(!vat)return pick(main,true,'');
    var r=pick(main,true,vat);
    if(!r&&vat==='ex')r=pick('[class*="no-vat"], [class*="no_vat"], [class*="ex-vat"]',false,'');
    if(!r&&vat==='inc')r=pick('[class*="has-vat"], [class*="with-vat"], [class*="inc-vat"]',false,'');
    if(r)r.vat=vat;
    return r;
  }
  /* The main price exactly as the customer sees it: the first price in the price box's visible text, with its Inc / Ex VAT label */
  function headline(){
    var pb=document.querySelector('.ss-pdp .ss-pricebox');if(!pb)return null;
    var vis=(pb.innerText||'').replace(/ /g,' ');
    var m=vis.match(AMT);if(!m)return null;
    var after=vis.slice(m.index,m.index+m[0].length+16);
    var tg=document.getElementById('vatToggle');
    return {text:m[0].replace(/\s+/g,''),value:num(m[0]),vat:vatOf(after)||(tg?(tg.checked?'inc':'ex'):'')};
  }
  /* VAT rate from BSS's own inc / ex VAT pair for this product (e.g. 79,95 / 65,00 = 1.23) */
  function vatRate(){
    var pb=document.querySelector('.ss-pdp .ss-pricebox');if(!pb)return NaN;
    var a=pb.querySelector('[class*="has-vat"]'),b=pb.querySelector('[class*="no-vat"]');
    var x=a&&txt(a).match(AMT),y=b&&txt(b).match(AMT);
    if(x&&y){var r=num(x[0])/num(y[0]);if(r>1.001&&r<1.3)return r;}
    var cur=(document.querySelector('.ss-pdp .ss-pricebox')||{}).textContent||'';
    return /£/.test(cur)?1.2:1.23;
  }
  function fmt(v,sample){
    var sym=(sample.match(/[€£$]/)||['€'])[0],comma=/,\d{2}(?!\d)/.test(sample)||!/\.\d{2}(?!\d)/.test(sample);
    var n=(Math.round(v*100)/100).toFixed(2);if(comma)n=n.replace('.',',');
    return sample.trim().indexOf(sym)===0?sym+n:n+sym;
  }
  function vatOf(s){s=String(s||'');if(/\bex(c|cl)?\.?\s*vat|excl/i.test(s))return 'ex';if(/\binc(l)?\.?\s*vat|incl/i.test(s))return 'inc';return '';}
  function label(t){if(t.max===Infinity)return t.min+'+ units';if(t.max===t.min)return t.min+(t.min===1?' unit':' units');return t.min+'–'+t.max+' units';}
  var ICON='<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.6 13.4l-7.2 7.2a2 2 0 0 1-2.8 0L3 13V3h10l7.6 7.6a2 2 0 0 1 0 2.8z"/><circle cx="7.5" cy="7.5" r="1.5"/></svg>';
  var TICK='<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6L9 17l-5-5"/></svg>';

  var sig='',state=null;
  function qtyInput(){return document.querySelector('.ss-pdp #ss-product-form .ss-qty__input');}
  function build(){
    var table=findTable();
    var old=document.querySelector('.ss-pdp .ss-qbx');
    if(!table){if(old&&!document.querySelector('.ss-pdp .bss-b2b-qb-table *')){old.remove();sig='';}return;}
    var tiers=parse(table);if(!tiers.length)return;
    var vat=tiers[0].vat,head=headline(),base=null;
    if(head){
      base={text:head.text,value:head.value,vat:head.vat};
      /* BSS sometimes lists the tiers ex VAT while the page shows inc VAT (or the other way): convert so everything matches the main price */
      /* The header Inc / Ex VAT switch decides what the cards show */
      var tg=document.getElementById('vatToggle'),want=tg?(tg.checked?'inc':'ex'):(head.vat||vat),r=vatRate();
      function conv(v,from){if(isNaN(v)||!from||from===want)return v;return from==='ex'?v*r:v/r;}
      var headInc=head.vat==='ex'?head.value*r:head.value;
      var me=document.querySelector('.ss-pdp .ss-price .price[data-ss-price]'),mt=me?txt(me):'',mm=mt.match(AMT);
      if(mm){var ti=vatOf(mt)==='ex'?num(mm[0])*r:num(mm[0]);if(ti>0&&ti<headInc-0.02)headInc=ti;}
      base.value=want==='ex'?headInc/r:headInc;base.text=fmt(base.value,head.text);
      tiers.forEach(function(t){if(isNaN(t.value)||!t.vat||t.vat===want)return;t.value=conv(t.value,t.vat);t.price=fmt(t.value,t.price);t.vat=want;});
      vat=want;
    }else{base=basePrice(vat);}
    var s=JSON.stringify(tiers)+'|'+(base&&base.text);
    var src=table.closest('.bss-b2b-qb-table')||table,up=src;
    while(up.parentElement&&up.parentElement.closest&&up.parentElement.closest('.bss-b2b-qb-table')){up=up.parentElement.closest('.bss-b2b-qb-table');}
    src=up;
    src.classList.add('ss-qbx-src');src.style.setProperty('display','none','important');
    /* BSS's own red "Buy More - Save More" heading can sit just outside the table box */
    [src.previousElementSibling,src.parentElement&&src.parentElement.previousElementSibling].forEach(function(h){
      if(h&&!h.querySelector('table')&&!h.classList.contains('ss-qbx')&&/buy\s*more/i.test(txt(h))&&txt(h).length<60){h.classList.add('ss-qbx-src');h.style.setProperty('display','none','important');}
    });
    Array.prototype.forEach.call(document.querySelectorAll('.ss-pdp .ss-buybox [class*="bss"]'),function(h){
      if(!h.querySelector('table')&&!h.closest('.ss-qbx')&&/^buy\s*more\s*[-–]\s*save\s*more$/i.test(txt(h))){h.classList.add('ss-qbx-src');h.style.setProperty('display','none','important');}
    });
    if(old&&s===sig){mark();return;}
    sig=s;
    var list=tiers.slice();
    if(base&&list[0].min>1){list.unshift({min:1,max:list[0].min-1,price:base.text,value:base.value,base:true});}
    var bv=base?base.value:NaN;
    var vl=vat==='ex'?' ex VAT':(vat==='inc'?' inc VAT':'');
    var html='<div class="ss-qbx__head"><span class="ss-qbx__title">'+ICON+'Buy more, save more</span><span class="ss-qbx__sub">Price per unit'+vl+'</span></div><div class="ss-qbx__tiers" role="list">';
    list.forEach(function(t,i){
      var save='';
      if(t.base)save='<span class="ss-qbx__save is-base">Standard</span>';
      else if(!isNaN(t.value)&&bv>0&&t.value<bv){var p=Math.round((bv-t.value)/bv*100);save='<span class="ss-qbx__save">Save '+(p<1?'<1':p)+'%</span>';}
      else if(!isNaN(t.pct))save='<span class="ss-qbx__save">Save '+t.pct+'%</span>';
      var price=t.price||(!isNaN(t.pct)&&bv>0?'-'+t.pct+'%':'');
      html+='<button type="button" role="listitem" class="ss-qbx__tier" data-i="'+i+'" data-min="'+t.min+'" aria-label="'+esc(label(t)+', '+price+' each')+'"><span class="ss-qbx__tick">'+TICK+'</span><span class="ss-qbx__qty">'+esc(label(t))+'</span><span class="ss-qbx__price">'+esc(price)+'<small> each</small></span>'+save+'</button>';
    });
    html+='</div><p class="ss-qbx__nudge" aria-live="polite"></p>';
    if(location.search.indexOf('ssdebug')>-1)html+='<pre style="white-space:pre-wrap;font:11px monospace;margin:10px 0 0;color:#545b63">'+esc('head='+JSON.stringify(head)+' want='+vat+' rate='+vatRate().toFixed(3)+' tiers='+JSON.stringify(tiers.map(function(t){return t.price+'/'+t.vat;})))+'</pre>';
    var w=old||document.createElement('div');
    w.className='ss-qbx';w.innerHTML=html;
    if(!old){var host=src.parentNode;host.insertBefore(w,src);}
    state={list:list,box:w};
    mark();
  }
  function mark(){
    if(!state)return;var q=qtyInput(),n=q?parseInt(q.value,10)||1:1,next=null;
    Array.prototype.forEach.call(state.box.querySelectorAll('.ss-qbx__tier'),function(b){
      var t=state.list[+b.getAttribute('data-i')],on=n>=t.min&&n<=t.max;
      b.classList.toggle('is-active',on);b.setAttribute('aria-pressed',on?'true':'false');
      if(!next&&t.min>n&&!t.base)next=t;
    });
    var nd=state.box.querySelector('.ss-qbx__nudge');
    if(nd){nd.innerHTML=next?'Add <strong>'+(next.min-n)+' more</strong> to pay <strong>'+esc(next.price||('-'+next.pct+'%'))+'</strong> each.':'<strong>Best price unlocked.</strong> You’re getting the lowest price per unit.';}
  }
  document.addEventListener('click',function(e){
    var b=e.target.closest&&e.target.closest('.ss-qbx__tier');if(!b||!state)return;
    var q=qtyInput();if(!q)return;
    var v=+b.getAttribute('data-min'),mx=parseInt(q.getAttribute('max'),10);if(mx&&v>mx)v=mx;
    q.value=v;q.dispatchEvent(new Event('input',{bubbles:true}));q.dispatchEvent(new Event('change',{bubbles:true}));mark();
  });
  document.addEventListener('input',function(e){if(e.target&&e.target.classList&&e.target.classList.contains('ss-qty__input'))mark();});
  document.addEventListener('change',function(e){if(e.target&&e.target.classList&&e.target.classList.contains('ss-qty__input'))mark();});
  document.addEventListener('click',function(e){if(e.target.closest&&e.target.closest('.ss-pdp [data-ss-step]'))setTimeout(mark,40);});
  var bt;function soon(){clearTimeout(bt);bt=setTimeout(build,80);}
  document.addEventListener('DOMContentLoaded',function(){
    if(!document.querySelector('.ss-pdp'))return;
    build();
    var form=document.querySelector('.ss-pdp .ss-buybox');
    if(form&&window.MutationObserver)new MutationObserver(function(ms){for(var i=0;i<ms.length;i++){var t=ms[i].target;if(!(t.closest&&t.closest('.ss-qbx')))return soon();}}).observe(form,{childList:true,subtree:true,characterData:true});
  });
  window.addEventListener('load',soon);
  document.addEventListener('done_render_qb_table',soon);
  /* VAT switch: redraw the cards (BSS updates its prices a moment later, so redraw twice) */
  document.addEventListener('change',function(e){if(e.target&&e.target.id==='vatToggle'){sig='';soon();setTimeout(function(){sig='';build();},700);}});
})();
